/**
 * Mother's Day countdown timer.
 * Self-initialising, no dependencies.
 * Finds every .so-countdown element and counts down to data-target (ISO date string).
 */
(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function updateUnit(el, cls, val) {
    var num = el.querySelector(cls);
    if (!num) return;
    var next = pad(val);
    if (num.textContent !== next) {
      num.classList.remove('so-countdown__flip');
      // force reflow so the animation re-triggers
      // eslint-disable-next-line no-unused-expressions
      num.offsetWidth;
      num.classList.add('so-countdown__flip');
      num.textContent = next;
    }
  }

  function tick(el) {
    var target = new Date(el.dataset.target).getTime();
    if (isNaN(target)) return;

    var now = Date.now();
    var diff = target - now;

    if (diff <= 0) {
      var expired = el.dataset.expired || "Happy Mother's Day!";
      el.innerHTML =
        '<span class="so-countdown__expired">' +
        '<svg class="so-countdown__heart-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>' +
        expired +
        '</span>';
      return;
    }

    var days  = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var mins  = Math.floor((diff % 3600000) / 60000);
    var secs  = Math.floor((diff % 60000) / 1000);

    updateUnit(el, '.so-countdown__days',  days);
    updateUnit(el, '.so-countdown__hours', hours);
    updateUnit(el, '.so-countdown__mins',  mins);
    updateUnit(el, '.so-countdown__secs',  secs);
  }

  function init() {
    var countdowns = document.querySelectorAll('.so-countdown');
    if (!countdowns.length) return;

    countdowns.forEach(function (el) { tick(el); });

    setInterval(function () {
      countdowns.forEach(function (el) { tick(el); });
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
